import { TenantPermission } from "features/tenant";
import RestrictedRealm, {
  BasicRestrictedRealmProps
} from "../access-management/RestrictedRealm";
import { useRequestUserTenantPermissions } from "./useRequestUserTenantPermissions";

export default function RestrictedTenantRealm({
  requiredPermissions,
  silent = false,
  children,
  fallback
}: BasicRestrictedRealmProps<TenantPermission>) {
  const {
    data: { accessGranted, missingPermissions },
    loading,
    error
  } = useRequestUserTenantPermissions(requiredPermissions);
  return (
    <RestrictedRealm<TenantPermission>
      requiredPermissions={requiredPermissions}
      accessGranted={accessGranted}
      missingPermissions={missingPermissions}
      children={children}
      error={error}
      loading={loading}
      fallback={fallback}
      silent={silent}
      errorTitle="Unable to access tenant permissions"
    />
  );
}
